const termsAndConditions = `<h1>Terms and Conditions</h1>

<h4>Last updated: October 03, 2018</h4>

These Terms and Conditions ("Terms", "Terms and Conditions") govern your relationship with www.codingcoach.io website (the "Service") operated by Coding Coach ("us", "we", or "our").

Please read these Terms and Conditions carefully before using the Service.

Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.


By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.

<h2>Accounts</h2>

When you create an account with us, you must provide us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.

You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password, whether your password is with our Service or a third-party service.

You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.

You may not use as a username the name of another person or entity or that is not lawfully available for use, a name or trademark that is subject to any rights of another person or entity other than you without appropriate authorization, or a name that is otherwise offensive, vulgar or obscene.

<h2>Links To Other Websites</h2>

Our Service may contain links to third-party web sites or services that are not owned or controlled by Coding Coach.

Coding Coach has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that Coding Coach shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services.

We strongly advise you to read the terms and conditions and privacy policies of any third-party web sites or services that you visit.

<h2>Termination</h2>

We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue using the Service. Governing Law

These Terms shall be governed and construed in accordance with the laws of Baden-Württemberg, Germany, without regard to its conflict of law provisions.

Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service. 

<h2>Changes</h2>

We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 15 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.

By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.

<h2>Contact Us</h2>

If you have any questions about these Terms, please contact us.
`;

export default termsAndConditions;
